 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTMARK_COVER from '@/components/Text/Mark_cover'
 import TEXTMARK_TITLEPAGE from '@/components/Text/Mark_titlepage'
 import TEXTMARK_CONTENTS from '@/components/Text/Mark_contents'
 import TEXTMARK_DEDICATION from '@/components/Text/Mark_dedication'
 import TEXTMARK_GEN_PREF from '@/components/Text/Mark_gen_pref'
 import TEXTMARK_AUTH_PREF from '@/components/Text/Mark_auth_pref'
 import TEXTMARK_ABBREVIATIONS from '@/components/Text/Mark_abbreviations'
 import TEXTMARK_BIBLIOG from '@/components/Text/Mark_bibliog'
 import TEXTMARK_INTRO from '@/components/Text/Mark_intro'
 import TEXTMARK_ANALYSIS from '@/components/Text/Mark_analysis'
 import TEXTMARK_COMMENT1 from '@/components/Text/Mark_comment1'
 import TEXTMARK_COMMENT2 from '@/components/Text/Mark_comment2'
 import TEXTMARK_COMMENT3 from '@/components/Text/Mark_comment3'
 import TEXTMARK_COMMENT4 from '@/components/Text/Mark_comment4'
 import TEXTMARK_NOTES from '@/components/Text/Mark_notes'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Mark_contents",
 			"name" : "Text/Mark_contents",
 			"component" : TEXTMARK_CONTENTS
 		},
 		{
 			"path" : "/Text/Mark_dedication",
 			"name" : "Text/Mark_dedication",
 			"component" : TEXTMARK_DEDICATION
 		},
 		{
 			"path" : "/Text/Mark_gen_pref",
 			"name" : "Text/Mark_gen_pref",
 			"component" : TEXTMARK_GEN_PREF
 		},
 		{
 			"path" : "/Text/Mark_auth_pref",
 			"name" : "Text/Mark_auth_pref",
 			"component" : TEXTMARK_AUTH_PREF
 		},
 		{
 			"path" : "/Text/Mark_abbreviations",
 			"name" : "Text/Mark_abbreviations",
 			"component" : TEXTMARK_ABBREVIATIONS
 		},
 		{
 			"path" : "/Text/Mark_bibliog",
 			"name" : "Text/Mark_bibliog",
 			"component" : TEXTMARK_BIBLIOG
 		},
 		{
 			"path" : "/Text/Mark_intro",
 			"name" : "Text/Mark_intro",
 			"component" : TEXTMARK_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js